export default "__VITE_ASSET__BdQ3CzKS__"